export const windowWidth = () => window.innerWidth;
export const isPortable = () => windowWidth() <= 783;